export default {
      id: "UpperLimbFlexionExtension-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#UpperLimbFlexionExtension",
      toString: function () {
        return this.url;
      }
    }